<template>
    <div class="wrapp" ref="formContainer">
        <div class="bg"></div>
        <statistic :slug="slug" />
    </div>
</template>

<script>

    import Statistic from "../components/Statistic";

    export default {
        name: "Home",
        components: {
            Statistic
        },
        props: {
            slug: {
                type:    [String],
                default: null
            },
        }
    }
</script>

<style scoped>

</style>